import React, { Component } from "react";
import { Link } from "react-router-dom";
// Layout
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodPartners extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    // 如需 i18n，可用 t('key'); 目前先用英文静态文案，避免缺 key。
    const { t } = this.props;

    return (
      <>
      <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            {/* 🖼️ 页面顶部横幅 */}
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">{t("Robotics_For_Good_Partners_Title")}</h1>
                </div>
              </div>
            </div>

            {/* 🧭 面包屑导航 */}
            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Partners_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Partners_Link")}</li>
                </ul>
              </div>
            </div>

            {/* 🤝 Sponsors & Partners 主体内容 */}
            <div className="section-full content-inner bg-white m-t30">
              <div className="container">
                <div className="section-head style-1 text-center">
                  <h2 className="title">Sponsors & Partners</h2>
                </div>

                {/* Why Partner With Us */}
                <div className="row">
                  <div className="col-lg-12">
                    <h3 className="m-b15">Why Partner With Us</h3>
                    <p>
                      The <em>Robotics for Good Youth Challenge – Australia</em> is the official National Chapter of the
                      <strong> ITU AI for Good</strong> global program — the only UN-based youth robotics competition.
                    </p>
                    <p>
                      Organized by the <strong>Australian AI Olympiad (AAIO)</strong>, a non-profit organization, all sponsorship funds
                      and resources are used exclusively for event organization, student training, and international participation —
                      ensuring that every contribution directly benefits youth and education.
                    </p>

                    <ul className="list-checked primary m-b20">
                      <li>🌍 <strong>Align with the United Nations</strong> – Be part of a UN-based global robotics initiative</li>
                      <li>🎓 <strong>Empower STEM education</strong> – Support students aged 10–18, nurturing future innovators</li>
                      <li>🚀 <strong>Showcase social responsibility</strong> – Demonstrate commitment to sustainability and youth innovation</li>
                      <li>📢 <strong>Gain visibility</strong> – Receive recognition nationally and through ITU global channels</li>
                      <li>🤝 <strong>Expand networks</strong> – Connect with the UN, academia, and industry</li>
                    </ul>

                    <hr className="m-t20 m-b30" />

                    {/* Sponsorship Opportunities */}
                    <h3 className="m-b15">Sponsorship Opportunities</h3>
                    <ul className="list-arrow primary m-b20">
                      <li><strong>Financial Support</strong> – Fund competition organization, training, venue, and the National Final</li>
                      <li><strong>Event Sponsorship</strong> – Showcase your brand at the Australian National Competition</li>
                      <li><strong>Training Support</strong> – Fund workshops, tutorials, and learning resources</li>
                      <li><strong>Equipment Donation</strong> – Provide robotics kits, parts, or technical tools</li>
                      <li><strong>Awards & Recognition</strong> – Sponsor trophies, medals, or certificates</li>
                      <li><strong>Travel & Visa Support</strong> – Help cover travel, accommodation, or visa services for finalists & coaches to Geneva</li>
                      <li><strong>Volunteer & In-kind Support</strong> – Offer mentors, volunteers, or event resources</li>
                    </ul>

                    <hr className="m-t20 m-b30" />

                    {/* Guidelines */}
                    <h3 className="m-b15">Guidelines</h3>
                    <ul className="list-dotted m-b20">
                      <li>All sponsorships must comply with ITU/AI for Good branding rules</li>
                      <li>Sponsors cannot use ITU, UN, or AI for Good logos independently</li>
                      <li>
                        Local sponsorships are welcome, but sponsors must not approach ITU global partners
                        (AWS, Microsoft, Huawei, Adobe, etc.)
                      </li>
                      <li>All sponsorships require ITU approval</li>
                    </ul>

                    <hr className="m-t20 m-b30" />

                    {/* Partnership Opportunities */}
                    <h3 className="m-b15">Partnership Opportunities</h3>
                    <ul className="list-hand m-b20">
                      <li><strong>Educational Partners</strong> – schools, universities, training providers</li>
                      <li><strong>Community Partners</strong> – youth organizations, non-profits</li>
                      <li><strong>Industry Partners</strong> – companies offering mentorship, internships, or career pathways</li>
                    </ul>

                    <hr className="m-t20 m-b30" />

                    {/* Become a Sponsor or Partner */}
                    <h3 className="m-b15">Become a Sponsor or Partner</h3>
                    <p className="m-b10">Interested in supporting the <em>Robotics for Good Youth Challenge – Australia</em>?</p>
                    <div> 
                      👉 Contact us for sponsorship opportunities 
                    </div>
                    <div> 
                      👉 Apply as a Partner  
                    </div>
                    <p className="m-b5"><strong>📧 Email:</strong> contact@aaio.com.au</p>

                    <hr className="m-t20 m-b30" />

                    {/* Our Current Partners */}
                    <h4 className="m-b15"><a href="/aoai-sponsor" style={{ textDecoration: 'underline' }}>Our Current Partners</a></h4>
                  </div>
                </div>
              </div>
            </div>
            {/* END Section */}
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(RoboticsForGoodPartners);
